import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="loading"
      className={clsx(
        'inline-block h-5 w-5 animate-spin rounded-full border-2 border-primary-600 border-t-transparent',
        className
      )}
    />
  );
}

/** Centered spinner used while a page or section loads. */
export function LoadingState({ label, className }: { label?: string; className?: string }) {
  const { t } = useTranslation();
  return (
    <div className={clsx('flex flex-col items-center justify-center gap-3 py-16', className)}>
      <Spinner className="h-8 w-8" />
      <p className="text-sm text-gray-500">{label ?? t('common.loading')}</p>
    </div>
  );
}
